import { OnlyOfficeEditor } from "@/components/common/OnlyOfficeEditor.tsx";
import { Button } from "@/components/core/buttons/button";
import { Form, FormField, FormGroup, FormItem, FormMessage } from "@/components/core/forms/form";
import { Input } from "@/components/core/forms/input";
import { Content } from "@/components/layouts/content";
import { useDocumentConfigMutation } from "@/features/dashboard/api/queries/document-config-queries.ts";
import { formTemplateQueryOptions, useFormTemplateMutation } from "@/features/dashboard/api/queries/form-templates-query.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

export const Route = createFileRoute("/_dashboard/form-templates_/$formId")({
	component: Page,
	loader: ({ context: { queryClient }, params }) => {
		return queryClient.ensureQueryData(formTemplateQueryOptions(params.formId));
	},
});

function Page() {
	const params = Route.useParams();
	const formTemplateMutation = useFormTemplateMutation();
	const formTemplateQuery = useSuspenseQuery(formTemplateQueryOptions(params.formId));
	const documentTokenMutation = useDocumentConfigMutation();
	const formTemplate = formTemplateQuery.data;
	const [docOpts, setDocOpts] = useState({
		token: "",
		options: {},
	});
	const form = useForm({
		defaultValues: {
			id: formTemplate.id,
			title: formTemplate.title,
			document_key: "",
			category: "Civil Procedure",
			type: "judicial",
		},
	});

	const handleSubmit = async (values: {
		id: string;
		title: string;
		document_key: string;
		category: string;
		type: string;
	}) => {
		await formTemplateMutation.mutateAsync(values);

		toast.success("Template has been updated");
	};

	useEffect(() => {
		documentTokenMutation
			.mutateAsync({
				file_type: "docx",
				title: formTemplate?.medias?.file_name || "Media name",
				mode: "edit",
				url: formTemplate?.medias?.original_url,
			})
			.then((response) => {
				setDocOpts({
					token: response.token,
					options: response.options,
				});
			});
	}, []);

	return (
		<Content pageName="Form Templates">
			<Form {...form}>
				<form className="flex flex-col max-w-base w-full h-full" onSubmit={form.handleSubmit(handleSubmit)}>
					<div className="flex flex-col w-full max-w-base p-6 gap-6">
						<div className="flex flex-row items-center justify-between w-full gap-4">
							<div className="inline-flex flex-col w-auto">
								<span className="text-xl text-foreground-dark font-semibold">
									<FormField
										control={form.control}
										name="title"
										render={({ field }) => (
											<FormItem>
												<FormGroup>
													<Input autoComplete="off" {...field} />
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</span>
							</div>
							<Button type="submit" variant="default">
								Save
							</Button>
						</div>
						<div className="flex flex-col w-full gap-4">
							<OnlyOfficeEditor token={docOpts.token} options={docOpts.options} />
						</div>
					</div>
				</form>
			</Form>
		</Content>
	);
}
